import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { modules } from '../data/content';
export function Modules() {
  return <section className="w-full bg-cream py-16 sm:py-24" aria-labelledby="contenido" data-id="element-80" data-mp="1vx2awcxf9qs5">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-81" data-mp="1vz57jft2yi5u">
        <div className="flex flex-col items-center" data-id="element-82" data-mp="20v3tyxuulq3m">
          <SectionHeading eyebrow="Contenido del libro" title="Contenido del libro digital" subtitle="Todo lo que vas a aprender y practicar" intro="Cada módulo fue diseñado para guiarte paso a paso, de menor a mayor intensidad, siempre sentada y siempre segura." data-id="element-83" data-mp="145w5pi2uh2w0" />
        </div>

        <ol className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-84" data-mp="1i5xfxo501mo5">
          {modules.map((mod, index) => <motion.li key={mod.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.45,
          ease: 'easeOut',
          delay: index % 3 * 0.08
        }} className="flex h-full flex-col rounded-3xl border border-linen bg-sand/70 p-7" data-id="element-85" data-mp="2oky59azir6lr" data-mpi={index}>
              <span className="font-display text-4xl font-semibold text-clay/70" data-id="element-86" data-mp="3oyhj9zwafivu">
                {mod.number}
              </span>
              <h3 className="mt-4 font-display text-2xl font-medium leading-snug text-ink" data-id="element-87" data-mp="3k32494mjngxu">
                {mod.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-muted sm:text-lg" data-id="element-88" data-mp="3aamma7b8yscy">
                {mod.description}
              </p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}